import { render } from "./Heating.vue?vue&type=template&id=2ee2d5fe"
import script from "./Heating.vue?vue&type=script&lang=js"
export * from "./Heating.vue?vue&type=script&lang=js"

import exportComponent from "/opt/buildhome/repo/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__